class OrganizerPermissions {
    constructor({ show = false } = {}) {
        this.show = show
    }
}

export default OrganizerPermissions
